import { STYLE_UNITS } from '@/styles'

export const headerIds = { root: 'header' }

export const headerClasses = {
  container: 'header--container',
  package: 'header--package',
  logo: 'header--brand-logo',
  logoFanatics: 'header--brand-logo-fanatics',
  logoFanaticsIcon: 'header--brand-logo-fanatics-icon',
  logoStackedIcon: 'header--brand-logo-stacked-icon',
  logoIcon: 'header--brand-logo-icon',
  logoWrapper: 'header--logo-wrapper',
  configLogoImage: 'header--config-logo-image',
  actionWrapper: 'header--action-wrapper',
  hasPackage: 'header--has-package',
  flagIcon: 'header--flag-icon',
  eventInfoWrapper: 'header--event-info-wrapper',
  transparent: 'header--transparent',
}

export const headerDimensions = {
  height: 70,
  gap: 2.5,
  gapInPx: 2.5 * STYLE_UNITS.SPACING_MULTIPLIER, // 1 unit = 8px
  logo: {
    desktop: 170,
    mobile: 120,
    stackedIconMobile: 90,
    iconMobile: 34,
  },
}
